// Russian Advanced Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔romanization, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const russianAdvancedItems: VocabularyItem[] = [
  // Abstract Concepts (1-10)
  {
    id: 'ru-adv-001',
    target: 'Счастье',
    english: 'Happiness',
    romanization: 'Schastye',
    definition: 'A state of well-being and contentment',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-002',
    target: 'Успех',
    english: 'Success',
    romanization: 'Uspekh',
    definition: 'The achievement of a goal',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-003',
    target: 'Опыт',
    english: 'Experience',
    romanization: 'Opyt',
    definition: 'Knowledge gained through involvement',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-004',
    target: 'Возможность',
    english: 'Opportunity',
    romanization: 'Vozmozhnost',
    definition: 'A favorable circumstance for action',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-005',
    target: 'Ответственность',
    english: 'Responsibility',
    romanization: 'Otvetstvennost',
    definition: 'A duty to deal with something',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-006',
    target: 'Культура',
    english: 'Culture',
    romanization: 'Kultura',
    definition: 'The customs and beliefs of a group',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-007',
    target: 'Окружающая среда',
    english: 'Environment',
    romanization: 'Okruzhayushchaya sreda',
    definition: 'The surroundings one lives in',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-008',
    target: 'Общество',
    english: 'Society',
    romanization: 'Obshchestvo',
    definition: 'The community of people living together',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-009',
    target: 'Отношения',
    english: 'Relationship',
    romanization: 'Otnosheniya',
    definition: 'The connection between people',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-010',
    target: 'Влияние',
    english: 'Influence',
    romanization: 'Vliyaniye',
    definition: 'The power to affect something',
    partOfSpeech: 'noun'
  },

  // Russian Proverbs & Expressions (11-20)
  {
    id: 'ru-adv-011',
    target: 'Без труда не выловишь и рыбку из пруда',
    english: 'No pain, no gain',
    romanization: 'Bez truda ne vylovish i rybku iz pruda',
    definition: 'Success requires effort and hard work',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-012',
    target: 'Лучше поздно, чем никогда',
    english: 'Better late than never',
    romanization: 'Luchshe pozdno, chem nikogda',
    definition: 'It is better to do something late than not at all',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-013',
    target: 'Семь раз отмерь, один раз отрежь',
    english: 'Measure twice, cut once',
    romanization: 'Sem raz otmer, odin raz otrezh',
    definition: 'Think carefully before acting',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-014',
    target: 'Не говори гоп, пока не перепрыгнешь',
    english: 'Don\'t count your chickens before they hatch',
    romanization: 'Ne govori gop, poka ne pereprygnesh',
    definition: 'Don\'t celebrate success prematurely',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-015',
    target: 'Утро вечера мудренее',
    english: 'Sleep on it',
    romanization: 'Utro vechera mudrenee',
    definition: 'Morning is wiser than evening',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-016',
    target: 'Что посеешь, то и пожнёшь',
    english: 'You reap what you sow',
    romanization: 'Chto poseyesh, to i pozhnёsh',
    definition: 'Actions have consequences',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-017',
    target: 'Друзья познаются в беде',
    english: 'A friend in need is a friend indeed',
    romanization: 'Druzya poznayutsya v bede',
    definition: 'True friends help during difficult times',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-018',
    target: 'Тише едешь, дальше будешь',
    english: 'Slow and steady wins the race',
    romanization: 'Tishe yedesh, dalshe budesh',
    definition: 'Patience leads to better results',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-019',
    target: 'В гостях хорошо, а дома лучше',
    english: 'There\'s no place like home',
    romanization: 'V gostyakh khorosho, a doma luchshe',
    definition: 'Home is the best place to be',
    partOfSpeech: 'proverb'
  },
  {
    id: 'ru-adv-020',
    target: 'Повторение - мать учения',
    english: 'Practice makes perfect',
    romanization: 'Povtoreniye - mat ucheniya',
    definition: 'Repetition is key to learning',
    partOfSpeech: 'proverb'
  },

  // Professional & Academic (21-30)
  {
    id: 'ru-adv-021',
    target: 'Развитие',
    english: 'Development',
    romanization: 'Razvitiye',
    definition: 'The process of growth or advancement',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-022',
    target: 'Технология',
    english: 'Technology',
    romanization: 'Tekhnologiya',
    definition: 'Scientific knowledge applied practically',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-023',
    target: 'Экономика',
    english: 'Economy',
    romanization: 'Ekonomika',
    definition: 'The system of money and trade',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-024',
    target: 'Исследование',
    english: 'Research',
    romanization: 'Issledovaniye',
    definition: 'Systematic investigation to establish facts',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-025',
    target: 'Образование',
    english: 'Education',
    romanization: 'Obrazovaniye',
    definition: 'The process of teaching and learning',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-026',
    target: 'Правительство',
    english: 'Government',
    romanization: 'Pravitelstvo',
    definition: 'The governing body of a nation',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-027',
    target: 'Закон',
    english: 'Law',
    romanization: 'Zakon',
    definition: 'The system of rules in a society',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-028',
    target: 'История',
    english: 'History',
    romanization: 'Istoriya',
    definition: 'The study of past events',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-029',
    target: 'Искусство',
    english: 'Art',
    romanization: 'Iskusstvo',
    definition: 'Creative expression through various media',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-030',
    target: 'Философия',
    english: 'Philosophy',
    romanization: 'Filosofiya',
    definition: 'The study of fundamental questions',
    partOfSpeech: 'noun'
  },

  // Emotions & States (31-40)
  {
    id: 'ru-adv-031',
    target: 'Беспокойство',
    english: 'Anxiety / Worry',
    romanization: 'Bespokoystvo',
    definition: 'A feeling of worry or unease',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-adv-032',
    target: 'Удовлетворённый',
    english: 'Satisfied',
    romanization: 'Udovletvoryonnyy',
    definition: 'Feeling content with something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-033',
    target: 'Разочарованный',
    english: 'Disappointed',
    romanization: 'Razocharovannyy',
    definition: 'Feeling let down by unmet expectations',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-034',
    target: 'Взволнованный',
    english: 'Excited',
    romanization: 'Vzvolnovannyy',
    definition: 'Feeling enthusiastic and eager',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-035',
    target: 'Одинокий',
    english: 'Lonely',
    romanization: 'Odinokiy',
    definition: 'Feeling sad from being alone',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-036',
    target: 'Гордый',
    english: 'Proud',
    romanization: 'Gordyy',
    definition: 'Feeling satisfaction from achievements',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-037',
    target: 'Завидовать',
    english: 'To envy',
    romanization: 'Zavidovat',
    definition: 'To desire what someone else has',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-038',
    target: 'Сожалеть',
    english: 'To regret',
    romanization: 'Sozhalet',
    definition: 'To feel sorry about past actions',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-039',
    target: 'Благодарный',
    english: 'Grateful',
    romanization: 'Blagodarnyy',
    definition: 'Feeling thankful for something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'ru-adv-040',
    target: 'Неловкий',
    english: 'Awkward',
    romanization: 'Nelovkiy',
    definition: 'Feeling uncomfortable in a situation',
    partOfSpeech: 'adjective'
  },

  // Complex Actions (41-50)
  {
    id: 'ru-adv-041',
    target: 'Решать',
    english: 'To solve / To decide',
    romanization: 'Reshat',
    definition: 'To find an answer to a problem',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-042',
    target: 'Рассматривать',
    english: 'To consider',
    romanization: 'Rassmatrivat',
    definition: 'To think carefully about something',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-043',
    target: 'Принимать решение',
    english: 'To make a decision',
    romanization: 'Prinimat resheniye',
    definition: 'To make a choice or resolution',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-044',
    target: 'Принимать',
    english: 'To accept',
    romanization: 'Prinimat',
    definition: 'To receive or agree to something',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-045',
    target: 'Отказывать',
    english: 'To refuse',
    romanization: 'Otkazyvat',
    definition: 'To decline or say no to something',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-046',
    target: 'Обсуждать',
    english: 'To discuss',
    romanization: 'Obsuzhat',
    definition: 'To talk about something in detail',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-047',
    target: 'Напоминать',
    english: 'To remind',
    romanization: 'Napominat',
    definition: 'To cause someone to remember',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-048',
    target: 'Выражать',
    english: 'To express',
    romanization: 'Vyrazhat',
    definition: 'To convey thoughts or feelings',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-049',
    target: 'Доказывать',
    english: 'To prove',
    romanization: 'Dokazyvat',
    definition: 'To demonstrate the truth of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-adv-050',
    target: 'Обещать',
    english: 'To promise',
    romanization: 'Obeshchat',
    definition: 'To commit to doing something',
    partOfSpeech: 'verb'
  }
];
